var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stat',{attrs:{"title":_vm.$t('dashboard.gainssum.title'),"loading":_vm.loading}},[_c('div',{staticClass:"stat"},[(_vm.total !== undefined)?_c('price',{staticClass:"price",attrs:{"value":_vm.total}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"date"},[(_vm.from)?_c('date',{attrs:{"value":_vm.from,"format":"short"}}):_vm._e(),_vm._v("\n      -\n      "),(_vm.to)?_c('date',{attrs:{"value":_vm.to,"format":"short"}}):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3215ef06","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/GainsSum.vue
// module id = null
// module chunks = 